module.exports = __webpack_public_path__ + "02c82842fe31b4dc7931533ad04a69d4.png";